"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2709],{

/***/ 8620:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1987);
/* harmony import */ var _design_system_pc__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9903);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var ResponsiveBox = function(_param) {
    var children = _param.children, props = _objectWithoutProperties(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_design_system_pc__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, _objectSpreadProps(_objectSpread({}, props), {
        width: "100%",
        minWidth: 1170,
        maxWidth: 1400,
        mx: "auto",
        children: children
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ResponsiveBox);


/***/ }),

/***/ 2709:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ExpertDetail": function() { return /* reexport */ ExpertDetail_ExpertDetail; },
  "ExpertProfile": function() { return /* reexport */ ExpertDetail_ExpertProfile; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(1261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(1987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@design-system-pc-virtual-d22d27d8bb/0/cache/@design-system-pc-npm-4.8.3-1f3e725f24-63eaa81be8.zip/node_modules/@design-system/pc/dist/design-system-pc.js
var design_system_pc = __webpack_require__(9903);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@display-component-pc-virtual-4843018c89/0/cache/@display-component-pc-npm-5.0.5-beta.4-8d5a04944d-e6b425577d.zip/node_modules/@display-component/pc/dist/display-component-pc.js
var display_component_pc = __webpack_require__(823);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-769137b2ab/0/cache/next-npm-12.2.3-07d597c2b7-b13b42fbb3.zip/node_modules/next/dynamic.js
var dynamic = __webpack_require__(8380);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../.yarn/unplugged/styled-components-virtual-24edae5a63/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(278);
// EXTERNAL MODULE: ./src/components/ResponsiveBox/ResponsiveBox.tsx
var ResponsiveBox = __webpack_require__(8620);
// EXTERNAL MODULE: ../../.yarn/cache/lodash-npm-4.17.21-6382451519-eb835a2e51.zip/node_modules/lodash/lodash.js
var lodash = __webpack_require__(5735);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
// EXTERNAL MODULE: ../../.yarn/unplugged/swiper-npm-8.4.4-c63bd6daca/node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(6859);
;// CONCATENATED MODULE: ./src/components/svg/DoubleQuotesStart.tsx


var DoubleQuotesStart = function(param) {
    var width = param.width, height = param.height;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            width: width || "18",
            height: height || "15",
            viewBox: "0 0 18 15",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 14C0 14.5523 0.447715 15 1 15H6.48421C7.0365 15 7.48421 14.5523 7.48421 14V8.88991C7.48421 8.33762 7.0365 7.88991 6.48421 7.88991H5.07368C4.5214 7.88991 4.06074 7.43732 4.16886 6.89573C4.47772 5.34864 5.52713 4.2044 7.154 3.77885C7.6542 3.64801 8.05263 3.22808 8.05263 2.71105V1.08315C8.05263 0.499442 7.55208 0.0348305 6.97785 0.139542C2.49017 0.957861 0 4.52606 0 9.08257V14ZM9.94737 14C9.94737 14.5523 10.3951 15 10.9474 15H16.4316C16.9839 15 17.4316 14.5523 17.4316 14V8.88991C17.4316 8.33762 16.9839 7.88991 16.4316 7.88991H15.0211C14.4688 7.88991 14.0081 7.43732 14.1162 6.89573C14.4251 5.34864 15.4745 4.2044 17.1014 3.77885C17.6016 3.64801 18 3.22808 18 2.71105V1.08315C18 0.499442 17.4995 0.0348305 16.9252 0.139542C12.4375 0.957861 9.94737 4.52606 9.94737 9.08257V14Z",
                fill: "#EFEFEF"
            })
        })
    });
};
/* harmony default export */ var svg_DoubleQuotesStart = (DoubleQuotesStart);

// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-769137b2ab/0/cache/next-npm-12.2.3-07d597c2b7-b13b42fbb3.zip/node_modules/next/router.js
var next_router = __webpack_require__(1975);
// EXTERNAL MODULE: ./src/hooks/index.tsx + 5 modules
var hooks = __webpack_require__(3951);
;// CONCATENATED MODULE: ./src/feat-components/ExpertDetail/hooks/useExpertSlideItem.tsx



var useExpertSlideItem = function(param) {
    var item = param.item, initialScrap = param.initialScrap;
    var ref, ref1, ref2, ref3, ref4;
    var useScrapProps = {
        id: item.contentsNo,
        name: item.contentsTitle,
        landingUrl: (ref = item.appLinkInfoDto) === null || ref === void 0 ? void 0 : ref.linkUrl,
        imageUrl: ((ref1 = item.imageInfo) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.images) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.imageUrl) || "",
        scrapTypeCode: "CONSTRUCTION_CASE",
        scrapYn: initialScrap ? "Y" : "N"
    };
    var router = (0,next_router.useRouter)();
    var ref5 = (0,hooks/* useScrap */.j8)(useScrapProps), hasScrap = ref5.hasScrap, handleScrap = ref5.handleScrap;
    var handleClickItem = (0,react.useCallback)(function() {
        var ref;
        router.push((ref = item.appLinkInfoDto) === null || ref === void 0 ? void 0 : ref.linkUrl);
    }, [
        (ref4 = item.appLinkInfoDto) === null || ref4 === void 0 ? void 0 : ref4.linkUrl,
        router
    ]);
    return {
        hasScrap: hasScrap,
        handleScrap: handleScrap,
        handleClickItem: handleClickItem
    };
};
/* harmony default export */ var hooks_useExpertSlideItem = (useExpertSlideItem);

// EXTERNAL MODULE: ./src/services/tracking.ts
var tracking = __webpack_require__(9676);
;// CONCATENATED MODULE: ./src/feat-components/ExpertDetail/ExpertSlideItem.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}





var ExpertSlideItem = function(param) {
    var item = param.item, initialScrap = param.initialScrap, handleMutateScrapList = param.handleMutateScrapList;
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = hooks_useExpertSlideItem({
        item: item,
        initialScrap: initialScrap
    }), hasScrap = ref5.hasScrap, handleScrap = ref5.handleScrap, handleClickItem = ref5.handleClickItem;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* SquareVerticalContentUnit */.ko, _objectSpread({
        img: (ref = item.imageInfo) === null || ref === void 0 ? void 0 : (ref1 = ref.images) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.imageUrl,
        imgFlags: item === null || item === void 0 ? void 0 : (ref3 = item.imageInfo) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.tagInfo) === null || ref4 === void 0 ? void 0 : ref4.map(function(tag) {
            return {
                variant: tag.style || "",
                textColor: tag.textColor || "",
                color: tag.styleColor || "",
                content: tag.name || ""
            };
        }),
        isShowBookmark: item.isScrap,
        isCheckedBookmark: hasScrap,
        title: item.contentsTitle,
        info1: item.squareMeter,
        info2: item.cityCountryDistrict,
        handleClick: handleClickItem,
        handleClickBookmark: function() {
            handleScrap();
            handleMutateScrapList();
        }
    }, tracking/* default.tagGTM */.Z.tagGTM("expert_construction_case_slide_item", {
        "content-id": item.contentsNo
    })));
};
/* harmony default export */ var ExpertDetail_ExpertSlideItem = (ExpertSlideItem);

// EXTERNAL MODULE: ./src/hooks/useDisplayComponent.tsx
var useDisplayComponent = __webpack_require__(2095);
// EXTERNAL MODULE: ./src/hooks/useAuthenticated.ts
var useAuthenticated = __webpack_require__(457);
// EXTERNAL MODULE: ./src/di-container/common/scrap/gateway/client.ts
var client = __webpack_require__(1964);
// EXTERNAL MODULE: ../../.yarn/__virtual__/swr-virtual-b8afd7b304/0/cache/swr-npm-1.3.0-3a8f9fadf5-e7a184f0d5.zip/node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8749);
;// CONCATENATED MODULE: ./src/feat-components/ExpertDetail/hooks/useExpertProfile.tsx





var useExpertProfile = function(param) {
    var data = param.data;
    var ref, ref1;
    var ref2 = (0,react.useState)(false), isOpenConstructionCase = ref2[0], setIsOpenConstructionCase = ref2[1];
    var ref3 = (0,react.useState)(), SwiperAction = ref3[0], setSwiperAction = ref3[1];
    var ref4 = (0,react.useState)(), swiper = ref4[0], setSwiper = ref4[1];
    var ref5 = (0,react.useState)(false), isHover = ref5[0], setIsHover = ref5[1];
    var ref6 = (0,useDisplayComponent/* default */.Z)(), handleNewLink = ref6.handleNewLink, handleAction = ref6.handleAction;
    var isAuthenticated = (0,useAuthenticated/* default */.Z)().isAuthenticated;
    var getScraps = (0,client/* scrapGateway */.N)().getScraps;
    var ref7 = (0,dist/* default */.ZP)("scraped_construction_list_by_".concat(data.code), function() {
        return getScraps.exec({
            scrapTypeCode: "CONSTRUCTION_CASE"
        });
    }), scrapApiResponse = ref7.data, handleMutateScrapList = ref7.mutate;
    var scrapList = (0,react.useMemo)(function() {
        var ref, ref1;
        return (scrapApiResponse === null || scrapApiResponse === void 0 ? void 0 : (ref = scrapApiResponse.data) === null || ref === void 0 ? void 0 : (ref1 = ref.scraps) === null || ref1 === void 0 ? void 0 : ref1.content) || [];
    }, [
        scrapApiResponse === null || scrapApiResponse === void 0 ? void 0 : (ref = scrapApiResponse.data) === null || ref === void 0 ? void 0 : (ref1 = ref.scraps) === null || ref1 === void 0 ? void 0 : ref1.content
    ]);
    var handleOpenConstructionCase = (0,react.useCallback)(function() {
        return setIsOpenConstructionCase(true);
    }, []);
    var handleCloseConstructionCase = (0,react.useCallback)(function() {
        return setIsOpenConstructionCase(false);
    }, []);
    var handleClickNext = (0,react.useCallback)(function() {
        SwiperAction === null || SwiperAction === void 0 ? void 0 : SwiperAction.slideNext();
    }, [
        SwiperAction
    ]);
    var handleClickPrev = (0,react.useCallback)(function() {
        SwiperAction === null || SwiperAction === void 0 ? void 0 : SwiperAction.slidePrev();
    }, [
        SwiperAction
    ]);
    (0,react.useEffect)(function() {
        if (setSwiperAction && swiper) {
            setSwiperAction(swiper);
        }
    }, [
        setSwiperAction,
        swiper
    ]);
    return {
        scrapList: scrapList,
        handleMutateScrapList: handleMutateScrapList,
        isOpenConstructionCase: isOpenConstructionCase,
        handleNewLink: handleNewLink,
        handleAction: handleAction,
        isAuthenticated: isAuthenticated,
        handleOpenConstructionCase: handleOpenConstructionCase,
        handleCloseConstructionCase: handleCloseConstructionCase,
        setSwiper: setSwiper,
        isHover: isHover,
        setIsHover: setIsHover,
        handleClickNext: handleClickNext,
        handleClickPrev: handleClickPrev
    };
};
/* harmony default export */ var hooks_useExpertProfile = (useExpertProfile);

// EXTERNAL MODULE: ./src/styles/index.ts
var styles = __webpack_require__(2655);
;// CONCATENATED MODULE: ./src/feat-components/ExpertDetail/ExpertProfile.tsx
function ExpertProfile_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ExpertProfile_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ExpertProfile_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}












var ExpertConstructionCase = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4605).then(__webpack_require__.bind(__webpack_require__, 4605));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4605)
            ];
        }
    }
});
var ExpertProfile = function(param) {
    var data = param.data, isBestRD = param.isBestRD, handleRequestConsult = param.handleRequestConsult, profileAreaRef = param.profileAreaRef, constructionCaseData = param.constructionCaseData;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var ref6 = hooks_useExpertProfile({
        data: data
    }), scrapList = ref6.scrapList, handleMutateScrapList = ref6.handleMutateScrapList, isOpenConstructionCase = ref6.isOpenConstructionCase, handleOpenConstructionCase = ref6.handleOpenConstructionCase, handleCloseConstructionCase = ref6.handleCloseConstructionCase, setSwiper = ref6.setSwiper, isHover = ref6.isHover, setIsHover = ref6.setIsHover, handleClickNext = ref6.handleClickNext, handleClickPrev = ref6.handleClickPrev;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Box */.xu, _objectSpreadProps(ExpertProfile_objectSpread({}, tracking/* default.tagGTM */.Z.tagGTM("expert_detail_profile")), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ResponsiveBox/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Box */.xu, {
                        ref: profileAreaRef,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* HStack */.zn, {
                                mt: 48,
                                space: "space-between",
                                alignment: "start",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* HStack */.zn, {
                                        space: 24,
                                        alignment: "start",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Box */.xu, {
                                                width: "max-content",
                                                position: "relative",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Profile */.NZ, {
                                                        size: "xlg",
                                                        src: (ref = data.image) === null || ref === void 0 ? void 0 : ref.url,
                                                        defaultImgType: "default_person",
                                                        fit: "cover"
                                                    }),
                                                    isBestRD && /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* NewFlag */.zI, {
                                                        size: "sm",
                                                        color: "color_chip.blue.500",
                                                        textColor: "color_chip.white",
                                                        content: "Best RD",
                                                        icon: {
                                                            variant: "ic_premium",
                                                            align: "left"
                                                        },
                                                        variant: "solid",
                                                        position: "absolute",
                                                        bottom: "0",
                                                        left: "calc(50% - 36px)"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Box */.xu, {
                                                maxWidth: 648,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Box */.xu, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                                                as: "span",
                                                                variant: "subTitle2",
                                                                color: "color_chip.primary",
                                                                children: data.name
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                                                as: "span",
                                                                variant: "subTitle2",
                                                                color: "color_chip.primary",
                                                                ml: "2px",
                                                                children: data.duty
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* HStack */.zn, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                                                variant: "label_lg_r",
                                                                color: "color_chip.gray.800",
                                                                mr: "2px",
                                                                children: "Rehaus Designer"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Tooltip */.u, {
                                                                accentColor: "color_chip.yellow.500",
                                                                direction: "bottom_left",
                                                                message: "한샘 공식 대리점 소속으로 인증된 인테리어 전문가를 말합니다.",
                                                                width: "232px",
                                                                zIndex: styles/* HEADER_Z_INDEX */.bf - 1,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Icongraphy */.Jb, ExpertProfile_objectSpread({
                                                                    resize: true,
                                                                    size: 20,
                                                                    variant: "ic_information",
                                                                    style: {
                                                                        cursor: "pointer"
                                                                    }
                                                                }, tracking/* default.tagGTM */.Z.tagGTM("expert_infomation_button")))
                                                            })
                                                        ]
                                                    }),
                                                    !lodash_default().isEmpty(data.badges) && /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* HStack */.zn, {
                                                        mt: 12,
                                                        space: 8,
                                                        flexWrap: "wrap",
                                                        children: (ref1 = data.badges) === null || ref1 === void 0 ? void 0 : ref1.map(function(param, idx) {
                                                            var name = param.name, upperCode = param.upperCode;
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* NewFlag */.zI, {
                                                                variant: "solid",
                                                                textColor: "color_chip.primary",
                                                                color: upperCode === "RD_BDG_DPT" ? "color_chip.blue.50" : "color_chip.yellow.50",
                                                                content: name
                                                            }, "expert_badge_".concat(data.code, "_").concat(idx));
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Box */.xu, {
                                                        mt: 24,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* HStack */.zn, {
                                                                space: 4,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Icongraphy */.Jb, {
                                                                        variant: "ic_comment",
                                                                        resize: true,
                                                                        size: 20,
                                                                        useFillColor: true,
                                                                        fillColor: "#666666"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                                                        variant: "label_lg_r",
                                                                        color: "color_chip.gray.700",
                                                                        children: "소개"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                                                variant: "body1",
                                                                color: "color_chip.primary",
                                                                mt: "8px",
                                                                children: data.introduction || "한샘 리하우스 디자이너 ".concat(data.name, " 입니다.")
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Box */.xu, {
                                        children: [
                                            isBestRD && /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Box */.xu, {
                                                borderRadius: 4,
                                                py: 16,
                                                px: 32,
                                                width: 252,
                                                border: "1px solid",
                                                borderColor: "color_chip.gray.200",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                                        variant: "subTitle7",
                                                        color: "color_chip.primary",
                                                        mb: "4px",
                                                        children: "Best RD란?"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                                        variant: "body2",
                                                        color: "color_chip.gray.800",
                                                        children: "고객 만족 평가와 매출 실적에서 우수함이 검증된 전문가 입니다."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* NewBasicButton */.vZ, _objectSpreadProps(ExpertProfile_objectSpread({
                                                emphasis: "high",
                                                size: "lg",
                                                width: 252,
                                                mt: 40,
                                                onClick: handleRequestConsult
                                            }, tracking/* default.tagGTM */.Z.tagGTM("expert_detail_consult_request_button")), {
                                                children: "상담신청"
                                            }))
                                        ]
                                    })
                                ]
                            }),
                            (!lodash_default().isEmpty(constructionCaseData) || lodash_default().isEmpty(data.workAvailableAreas)) && /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Box */.xu, {
                                width: "100%",
                                height: "8px",
                                backgroundColor: "color_chip.gray.50",
                                mt: 48
                            })
                        ]
                    }),
                    !lodash_default().isEmpty(constructionCaseData) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* HStack */.zn, {
                        mt: 80,
                        mb: 12,
                        space: "space-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                variant: "headline4",
                                children: "시공 콘텐츠"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* NewTextButton */.rT, _objectSpreadProps(ExpertProfile_objectSpread({
                                size: "lg",
                                color: "color_chip.gray.700",
                                icon: {
                                    variant: "ic_arrow_right",
                                    align: "right"
                                },
                                onClick: handleOpenConstructionCase
                            }, tracking/* default.tagGTM */.Z.tagGTM("expert_detail_construction_case_more_button")), {
                                children: "더보기"
                            }))
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Box */.xu, {
                        width: "100%",
                        position: "relative",
                        onMouseOver: function() {
                            return setIsHover(true);
                        },
                        onMouseLeave: function() {
                            return setIsHover(false);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                                spaceBetween: 32,
                                slidesPerView: 3,
                                autoHeight: true,
                                onSwiper: setSwiper,
                                children: lodash_default().slice(constructionCaseData, 0, 40).map(function(item) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpertDetail_ExpertSlideItem, {
                                            item: item,
                                            initialScrap: lodash_default().some(scrapList, {
                                                id: item.contentsNo
                                            }),
                                            handleMutateScrapList: handleMutateScrapList
                                        })
                                    }, "construction-case-popup-item".concat(item.contentsNo));
                                })
                            }),
                            isHover && constructionCaseData.length > 3 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* MovePagination */.iJ, ExpertProfile_objectSpread({
                                        size: "md",
                                        variant: "prev",
                                        onClick: handleClickPrev,
                                        position: "absolute",
                                        left: 0,
                                        top: "50%",
                                        zIndex: 10,
                                        style: {
                                            transform: "translateY(-50%)"
                                        }
                                    }, tracking/* default.tagGTM */.Z.tagGTM("expert_detail_construction_case_prev_button"))),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* MovePagination */.iJ, ExpertProfile_objectSpread({
                                        size: "md",
                                        variant: "next",
                                        onClick: handleClickNext,
                                        position: "absolute",
                                        right: 0,
                                        top: "50%",
                                        zIndex: 10,
                                        style: {
                                            transform: "translateY(-50%)"
                                        }
                                    }, tracking/* default.tagGTM */.Z.tagGTM("expert_detail_construction_case_next_button")))
                                ]
                            })
                        ]
                    })
                ]
            }),
            !lodash_default().isEmpty(data.workAvailableAreas) && /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Box */.xu, {
                py: 48,
                mt: 80,
                backgroundColor: "color_chip.blue.50",
                position: "relative",
                zIndex: 1,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ResponsiveBox/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                            variant: "headline4",
                            color: "color_chip.primary",
                            children: "상담 가능 지역"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Box */.xu, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* HStack */.zn, {
                                mt: 20,
                                style: {
                                    flexWrap: "wrap",
                                    gap: "12px"
                                },
                                children: (ref2 = data.workAvailableAreas) === null || ref2 === void 0 ? void 0 : ref2.slice(0, 20).map(function(item, idx) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Box */.xu, {
                                        p: 12,
                                        borderRadius: 2,
                                        border: "1px solid",
                                        borderColor: "color_chip.blue.100",
                                        backgroundColor: "color_chip.white",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                            variant: "label_lg_m",
                                            color: "color_chip.primary",
                                            children: item
                                        })
                                    }, "workable_area_".concat(idx));
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ResponsiveBox/* default */.Z, {
                children: [
                    ((ref3 = data.customerReview) === null || ref3 === void 0 ? void 0 : ref3.content) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* VStack */.gC, {
                        mt: 80,
                        px: 20,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(svg_DoubleQuotesStart, {
                                width: 28,
                                height: 28
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                variant: "headline4",
                                color: "color_chip.primary",
                                mt: 20,
                                children: "고객 만족 후기"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                variant: "body1",
                                color: "color_chip.primary",
                                textAlign: "center",
                                mt: 36,
                                maxWidth: 1000,
                                children: data.customerReview.content
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                variant: "label_md_m",
                                color: "color_chip.gray.700",
                                mt: 28,
                                pb: "8px",
                                children: "".concat(data.customerReview.address, " ").concat(data.customerReview.reviewer, " 고객님")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Box */.xu, {
                        mt: 80,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Box */.xu, {
                                pb: 12,
                                borderBottom: "1px solid",
                                borderBottomColor: "color_chip.gray.200",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                    variant: "headline4",
                                    color: "color_chip.primary",
                                    children: "기타 정보"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* HStack */.zn, {
                                space: 160,
                                alignment: "start",
                                mt: 36,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* HStack */.zn, {
                                        space: 8,
                                        alignment: "start",
                                        flex: 1,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* HStack */.zn, {
                                                space: 4,
                                                width: 100,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Icongraphy */.Jb, {
                                                        variant: "ic_check_done",
                                                        resize: true,
                                                        size: 16,
                                                        useFillColor: true,
                                                        color: "color_chip.gray.700"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                                        variant: "label_md_m",
                                                        color: "color_chip.gray.800",
                                                        children: "자격 인증"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Box */.xu, {
                                                children: !lodash_default().isEmpty(data.certifications) ? (ref4 = data.certifications) === null || ref4 === void 0 ? void 0 : ref4.map(function(item, idx) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                                        variant: "label_smd_r",
                                                        color: "color_chip.primary",
                                                        mt: idx !== 0 ? 12 : 0,
                                                        children: item
                                                    }, "qualification_certification_".concat(idx));
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                                    variant: "label_smd_r",
                                                    color: "color_chip.primary",
                                                    children: "-"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* HStack */.zn, {
                                        space: 8,
                                        alignment: "start",
                                        flex: 1,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* HStack */.zn, {
                                                space: 4,
                                                width: 100,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Icongraphy */.Jb, {
                                                        variant: "ic_paper",
                                                        resize: true,
                                                        size: 16,
                                                        useFillColor: true,
                                                        color: "color_chip.gray.700"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                                        variant: "label_md_m",
                                                        color: "color_chip.gray.800",
                                                        children: "교육 수료"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Box */.xu, {
                                                flex: 1,
                                                children: !lodash_default().isEmpty(data.courseCompletions) ? (ref5 = data.courseCompletions) === null || ref5 === void 0 ? void 0 : ref5.map(function(item, idx) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                                        variant: "label_smd_r",
                                                        color: "color_chip.primary",
                                                        mt: idx !== 0 ? 12 : 0,
                                                        children: item
                                                    }, "education_certificate_".concat(idx));
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                                    variant: "label_smd_r",
                                                    color: "color_chip.primary",
                                                    children: "-"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            !lodash_default().isEmpty(constructionCaseData) && /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* BasicPopup */.fz, {
                handleClose: handleCloseConstructionCase,
                size: "xlg",
                title: "시공 콘텐츠",
                isOpen: isOpenConstructionCase,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpertConstructionCase, {
                    expertId: data.code,
                    handleMutateScrapList: handleMutateScrapList,
                    scrapList: scrapList
                })
            })
        ]
    }));
};
/* harmony default export */ var ExpertDetail_ExpertProfile = (ExpertProfile);

// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-769137b2ab/0/cache/next-npm-12.2.3-07d597c2b7-b13b42fbb3.zip/node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(1861);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../../.yarn/cache/query-string-npm-7.1.1-55c6f31f52-b227d1f588.zip/node_modules/query-string/index.js
var query_string = __webpack_require__(6757);
;// CONCATENATED MODULE: ./src/feat-components/ExpertDetail/hooks/useExpertDetail.tsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}






var useExpertDetail = function(param) {
    var detailData = param.detailData;
    var ref = (0,react.useState)(false), isShowSticky = ref[0], setIsShowSticky = ref[1];
    var profileAreaRef = (0,react.useRef)(null);
    var router = (0,next_router.useRouter)();
    var y = (0,display_component_pc/* useWindowScrollDirection */.y3)().y;
    var isBestRD = (0,react.useMemo)(function() {
        var index = lodash_default().findIndex(detailData.agentDetail.reputations, {
            code: "RD_RPT_01"
        });
        return index >= 0;
    }, [
        detailData.agentDetail.reputations
    ]);
    var handleRequestConsult = (0,react.useCallback)(_asyncToGenerator(runtime_default().mark(function _callee() {
        var options;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    options = {
                        channelType: "OP23_01",
                        channelId: detailData.agency.upperId || detailData.agency.id,
                        agentEmployeeNo: detailData.agentDetail.code,
                        channelUrl: "".concat("https://remodeling.hanssem.com", "/expert/").concat(detailData.agentDetail.code)
                    };
                    router.push("/seq-consult?".concat(query_string.stringify(options)));
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        detailData.agency.id,
        detailData.agency.upperId,
        detailData.agentDetail.code,
        router, 
    ]);
    var goList = (0,react.useCallback)(function() {
        router.push("/expert/search");
    }, [
        router
    ]);
    (0,react.useEffect)(function() {
        if (profileAreaRef && y && y > profileAreaRef.current.clientHeight + 48) setIsShowSticky(true);
        if (profileAreaRef && y && y <= profileAreaRef.current.clientHeight + 48) setIsShowSticky(false);
    }, [
        y
    ]);
    return {
        isShowSticky: isShowSticky,
        profileAreaRef: profileAreaRef,
        isBestRD: isBestRD,
        handleRequestConsult: handleRequestConsult,
        goList: goList
    };
};
/* harmony default export */ var hooks_useExpertDetail = (useExpertDetail);

// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(7748);
;// CONCATENATED MODULE: ./src/feat-components/ExpertDetail/ExpertDetail.tsx
function ExpertDetail_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ExpertDetail_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ExpertDetail_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ExpertDetail_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function ExpertDetail_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ExpertDetail_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  cursor: pointer;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}











var AgencyInformation = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1633).then(__webpack_require__.bind(__webpack_require__, 1633));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(1633)
            ];
        }
    }
});
var StickyExpertProfile = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6457).then(__webpack_require__.bind(__webpack_require__, 6457));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6457)
            ];
        }
    }
});
var ExpertDetail = function(param) {
    var detailData = param.detailData, constructionCaseData = param.constructionCaseData;
    var ref;
    var ref1 = hooks_useExpertDetail({
        detailData: detailData
    }), isShowSticky = ref1.isShowSticky, profileAreaRef = ref1.profileAreaRef, handleRequestConsult = ref1.handleRequestConsult, goList = ref1.goList, isBestRD = ref1.isBestRD;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Box */.xu, ExpertDetail_objectSpreadProps(ExpertDetail_objectSpread({}, tracking/* default.tagGTM */.Z.tagGTM("expert_detail", {
        "expert-id": detailData.agentDetail.code
    })), {
        children: [
            isShowSticky && /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyExpertProfile, {
                isBestRD: isBestRD,
                expertId: detailData.agentDetail.code,
                imageUrl: (ref = detailData.agentDetail.image) === null || ref === void 0 ? void 0 : ref.url,
                name: detailData.agentDetail.name,
                duty: detailData.agentDetail.duty,
                handleRequestConsult: handleRequestConsult
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpertDetail_ExpertProfile, {
                data: detailData.agentDetail,
                handleRequestConsult: handleRequestConsult,
                isBestRD: isBestRD,
                profileAreaRef: profileAreaRef,
                constructionCaseData: constructionCaseData
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AgencyInformation, {
                data: detailData.agency
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledResponsiveBox, ExpertDetail_objectSpreadProps(ExpertDetail_objectSpread({
                mt: 64,
                mb: 160,
                onClick: goList
            }, tracking/* default.tagGTM */.Z.tagGTM("expert_detail_go_list_button")), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(display_component_pc/* LoadImage */.r6, {
                    width: "100%",
                    src: "".concat((0,utils/* getAsset */.Nh)("/assets/images/expert/expert_pc_detail_banner.png"))
                })
            }))
        ]
    }));
};
/* harmony default export */ var ExpertDetail_ExpertDetail = (ExpertDetail);
var StyledResponsiveBox = (0,styled_components_browser_esm/* default */.ZP)(ResponsiveBox/* default */.Z).withConfig({
    displayName: "ExpertDetail__StyledResponsiveBox",
    componentId: "sc-b200eb44-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/feat-components/ExpertDetail/index.tsx





/***/ }),

/***/ 2095:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _app_yarn_virtual_next_virtual_769137b2ab_0_cache_next_npm_12_2_3_07d597c2b7_b13b42fbb3_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1861);
/* harmony import */ var _app_yarn_virtual_next_virtual_769137b2ab_0_cache_next_npm_12_2_3_07d597c2b7_b13b42fbb3_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_yarn_virtual_next_virtual_769137b2ab_0_cache_next_npm_12_2_3_07d597c2b7_b13b42fbb3_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1987);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5735);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var query_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6757);
/* harmony import */ var _display_component_shared__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(1382);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1975);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _useGnb__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(914);
/* harmony import */ var _di_container_auth_gateway_client__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2885);
/* harmony import */ var _design_system_pc__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9903);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2655);
/* harmony import */ var _services_tracking__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9676);
/* provided dependency */ var process = __webpack_require__(8822);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}












var useDisplayComponent = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var handleOldOpenUrl = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        var url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", wiseLogParam = arguments.length > 1 ? arguments[1] : void 0;
        var targetUrl = _services_tracking__WEBPACK_IMPORTED_MODULE_10__/* ["default"].combineWiseLogParam */ .Z.combineWiseLogParam(url.startsWith("http") ? url : "".concat("https://remodeling.hanssem.com").concat(url.startsWith("/") ? "" : "/").concat(url), wiseLogParam);
        if (true) {
            window.location.href = targetUrl;
        } else {}
    }, [
        router
    ]);
    var ref = (0,_useGnb__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        viewType: _display_component_shared__WEBPACK_IMPORTED_MODULE_11__/* .VIEW_TYPE_REMODELING */ ._M,
        typeValue: _display_component_shared__WEBPACK_IMPORTED_MODULE_11__/* .TYPE_VALUE_MOBILE */ .is
    }), remodelingGnbMenuList = ref.gnbList;
    var handleAppLinkGnbRemodeling = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(appLink) {
        var found = lodash__WEBPACK_IMPORTED_MODULE_3___default().find(remodelingGnbMenuList, {
            dispTemplateNo: appLink === null || appLink === void 0 ? void 0 : appLink.appLinkVal
        });
        if (found) {
            var gnbModule = found.module;
            switch(gnbModule){
                case _display_component_shared__WEBPACK_IMPORTED_MODULE_11__/* .GNB_REMODELING_SECTION */ .UY:
                    handleOldOpenUrl("/main", appLink === null || appLink === void 0 ? void 0 : appLink.wiseLogParam);
                    break;
                case _display_component_shared__WEBPACK_IMPORTED_MODULE_11__/* .GNB_REMODELING_GOODS */ .gi:
                    handleOldOpenUrl("/goods", appLink === null || appLink === void 0 ? void 0 : appLink.wiseLogParam);
                    break;
                case _display_component_shared__WEBPACK_IMPORTED_MODULE_11__/* .GNB_REMODELING_SHOP */ .P1:
                    handleOldOpenUrl("/shop/search", appLink === null || appLink === void 0 ? void 0 : appLink.wiseLogParam);
                    break;
                case _display_component_shared__WEBPACK_IMPORTED_MODULE_11__/* .GNB_REMODELING_START */ .Sh:
                    handleOldOpenUrl("/remodeling-start", appLink === null || appLink === void 0 ? void 0 : appLink.wiseLogParam);
                    break;
                case _display_component_shared__WEBPACK_IMPORTED_MODULE_11__/* .GNB_REMODELING_EVENT */ ._L:
                    handleOldOpenUrl("/event", appLink === null || appLink === void 0 ? void 0 : appLink.wiseLogParam);
                    break;
                case _display_component_shared__WEBPACK_IMPORTED_MODULE_11__/* .GNB_REMODELING_REHOUSE */ .TH:
                    handleOldOpenUrl("/rehouse", appLink === null || appLink === void 0 ? void 0 : appLink.wiseLogParam);
                    break;
                default:
                    handleOldOpenUrl("/main?module=".concat(gnbModule), appLink === null || appLink === void 0 ? void 0 : appLink.wiseLogParam);
                    break;
            }
        } else {
            handleOldOpenUrl("/", appLink === null || appLink === void 0 ? void 0 : appLink.wiseLogParam);
        }
    }, [
        handleOldOpenUrl,
        remodelingGnbMenuList
    ]);
    var handleAppLinkCateRemodeling = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(appLink) {
        var query = query_string__WEBPACK_IMPORTED_MODULE_4__.stringify({
            ctgNo: appLink === null || appLink === void 0 ? void 0 : appLink.appLinkVal
        });
        handleOldOpenUrl("/goods?".concat(query), appLink === null || appLink === void 0 ? void 0 : appLink.wiseLogParam);
    }, [
        handleOldOpenUrl
    ]);
    var ref1 = (0,_useGnb__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        viewType: _display_component_shared__WEBPACK_IMPORTED_MODULE_11__/* .VIEW_TYPE_MALL */ .GG,
        typeValue: _display_component_shared__WEBPACK_IMPORTED_MODULE_11__/* .TYPE_VALUE_MOBILE */ .is
    }), mallGnbMenuList = ref1.gnbList;
    var handleAppLinkGnbMall = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(appLink) {
        var found = lodash__WEBPACK_IMPORTED_MODULE_3___default().find(mallGnbMenuList, {
            dispTemplateNo: appLink === null || appLink === void 0 ? void 0 : appLink.appLinkVal
        });
        if (found) {
            var gnbModule = found.module;
            switch(gnbModule){
                default:
                    handleOldOpenUrl("".concat(process.env.NEXT_PUBLIC_HANSSEMMALL_WEB_HOST, "/mall.html?module=").concat(gnbModule), appLink === null || appLink === void 0 ? void 0 : appLink.wiseLogParam);
                    break;
            }
        } else {
            handleOldOpenUrl("".concat(process.env.NEXT_PUBLIC_HANSSEMMALL_WEB_HOST, "/mall.html"), appLink === null || appLink === void 0 ? void 0 : appLink.wiseLogParam);
        }
    }, [
        handleOldOpenUrl,
        mallGnbMenuList
    ]);
    var handleAppLinkCateMall = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(appLink) {
        if (appLink && appLink.appLinkOption) {
            var categoryClass = appLink.appLinkOption.ctgDepth === "2" ? "L" : appLink.appLinkOption.ctgDepth === "3" ? "M" : "S";
            var query = query_string__WEBPACK_IMPORTED_MODULE_4__.stringify({
                ctgrNo: appLink.appLinkOption.ctgNo,
                categoryall: "".concat(categoryClass).concat(appLink.appLinkOption.ctgNo)
            });
            handleOldOpenUrl("".concat(process.env.NEXT_PUBLIC_HANSSEMMALL_WEB_HOST, "/category/goHsm").concat(categoryClass, "ctgy.do?").concat(query), appLink === null || appLink === void 0 ? void 0 : appLink.wiseLogParam);
        } else {
            handleOldOpenUrl("".concat(process.env.NEXT_PUBLIC_HANSSEMMALL_WEB_HOST), appLink === null || appLink === void 0 ? void 0 : appLink.wiseLogParam);
        }
    }, [
        handleOldOpenUrl
    ]);
    var ref2 = (0,_useGnb__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        viewType: _display_component_shared__WEBPACK_IMPORTED_MODULE_11__/* .VIEW_TYPE_HOMEIDEA */ .o2,
        typeValue: _display_component_shared__WEBPACK_IMPORTED_MODULE_11__/* .TYPE_VALUE_MOBILE */ .is
    }), homeIdeaGnbMenuList = ref2.gnbList;
    var handleAppLinkGnbHomeIdea = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(appLink) {
        var found = lodash__WEBPACK_IMPORTED_MODULE_3___default().find(homeIdeaGnbMenuList, {
            dispTemplateNo: appLink === null || appLink === void 0 ? void 0 : appLink.appLinkVal
        });
        if (found) {
            var gnbModule = found.module;
            switch(gnbModule){
                default:
                    handleOldOpenUrl("".concat(process.env.NEXT_PUBLIC_HANSSEMMALL_WEB_HOST, "/interior.html?module=").concat(gnbModule), appLink === null || appLink === void 0 ? void 0 : appLink.wiseLogParam);
                    break;
            }
        } else {
            handleOldOpenUrl("".concat(process.env.NEXT_PUBLIC_HANSSEMMALL_WEB_HOST, "/interior.html"), appLink === null || appLink === void 0 ? void 0 : appLink.wiseLogParam);
        }
    }, [
        handleOldOpenUrl,
        homeIdeaGnbMenuList
    ]);
    var handleLink = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(appLink) {
        if ((appLink === null || appLink === void 0 ? void 0 : appLink.appLinkTarget) === "LINK") {
            if (appLink === null || appLink === void 0 ? void 0 : appLink.appLinkVal) {
                handleOldOpenUrl(appLink.appLinkVal, appLink === null || appLink === void 0 ? void 0 : appLink.wiseLogParam);
            }
        }
        if ((appLink === null || appLink === void 0 ? void 0 : appLink.appLinkTarget) === "GNB") {
            switch(appLink === null || appLink === void 0 ? void 0 : appLink.appLinkChannel){
                case "MALL":
                    handleAppLinkGnbMall(appLink);
                    break;
                case "HOMEIDEA":
                    handleAppLinkGnbHomeIdea(appLink);
                    break;
                default:
                    handleAppLinkGnbRemodeling(appLink);
                    break;
            }
        }
        if ((appLink === null || appLink === void 0 ? void 0 : appLink.appLinkTarget) === "CATE") {
            switch(appLink === null || appLink === void 0 ? void 0 : appLink.appLinkChannel){
                case "MALL":
                    handleAppLinkCateMall(appLink);
                    break;
                default:
                    handleAppLinkCateRemodeling(appLink);
                    break;
            }
        }
        if ((appLink === null || appLink === void 0 ? void 0 : appLink.appLinkTarget) === "PLAN") {
            if (appLink === null || appLink === void 0 ? void 0 : appLink.appLinkVal) {
                handleOldOpenUrl("/event/".concat(appLink.appLinkVal, "?eventStatusType=ING"), appLink === null || appLink === void 0 ? void 0 : appLink.wiseLogParam);
            }
        }
    }, [
        handleAppLinkCateMall,
        handleAppLinkCateRemodeling,
        handleAppLinkGnbHomeIdea,
        handleAppLinkGnbMall,
        handleAppLinkGnbRemodeling,
        handleOldOpenUrl, 
    ]);
    /**
   * appLink와 defaultUrl을 받아 타겟 url로 랜딩하는 함수
   * @param {NewDisplayHandleLinkArgs} appLink 전시 데이터를 담고 있습니다.
   * @param {string} defaultUrl defaultUrl 을 입력하면 linkUrl 이 비어있을때 지정된 defaultUrl 로 이동합니다. linkUrl 과 defaultUrl 둘다 없다면 '/' 로 이동합니다.
   * @returns void
   */ var handleOpenUrl = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(appLink, defaultUrl) {
        var ref;
        if (false) {}
        var ref1;
        var url = (ref1 = (ref = appLink.applink) === null || ref === void 0 ? void 0 : ref.linkUrl) !== null && ref1 !== void 0 ? ref1 : defaultUrl || "/";
        if (appLink.isNewWindow) {
            window.open(url, "_blank");
        } else {
            window.location.href = url;
        }
    }, []);
    var handleNewLink = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(appLink) {
        var ref, ref1, ref2, ref3, ref4;
        ;
        if ((appLink === null || appLink === void 0 ? void 0 : appLink.applink) && !appLink.applink.appLinkTarget || (appLink === null || appLink === void 0 ? void 0 : (ref = appLink.applink) === null || ref === void 0 ? void 0 : ref.appLinkTarget) === "URL") {
            handleOpenUrl(appLink);
        }
        if ((appLink === null || appLink === void 0 ? void 0 : (ref1 = appLink.applink) === null || ref1 === void 0 ? void 0 : ref1.appLinkTarget) === "GNB") {
            var ref5;
            switch(appLink === null || appLink === void 0 ? void 0 : (ref5 = appLink.applink) === null || ref5 === void 0 ? void 0 : ref5.appLinkChannel){
                case "MAIN":
                    handleOpenUrl(appLink);
                    break;
                case "MALL":
                    handleOpenUrl(appLink, "".concat("https://store.hanssem.com", "/furnishing"));
                    break;
                case "HOMEIDEA":
                case "REMODELING":
                    handleOpenUrl(appLink, "".concat("https://store.hanssem.com", "/interior"));
                    break;
                default:
                    handleOpenUrl(appLink);
                    break;
            }
        }
        if ((appLink === null || appLink === void 0 ? void 0 : (ref2 = appLink.applink) === null || ref2 === void 0 ? void 0 : ref2.appLinkTarget) === "CATEGORY") {
            handleOpenUrl(appLink);
        }
        if ((appLink === null || appLink === void 0 ? void 0 : (ref3 = appLink.applink) === null || ref3 === void 0 ? void 0 : ref3.appLinkTarget) === "BNB") {
            var ref6;
            switch(appLink === null || appLink === void 0 ? void 0 : (ref6 = appLink.applink) === null || ref6 === void 0 ? void 0 : ref6.appLinkChannel){
                case "MAIN":
                    handleOpenUrl(appLink);
                    break;
                case "FURNISHING":
                    handleOpenUrl(appLink, "/furnishing");
                    break;
                case "INTERIOR":
                    handleOpenUrl(appLink, "/interior");
                    break;
                case "SHOPSEARCH":
                    handleOpenUrl(appLink, "/shop/search");
                    break;
                case "MY":
                    handleOpenUrl(appLink, "/my");
                    break;
                default:
                    handleOpenUrl(appLink);
                    break;
            }
        }
        if ((appLink === null || appLink === void 0 ? void 0 : (ref4 = appLink.applink) === null || ref4 === void 0 ? void 0 : ref4.appLinkTarget) === "PLAN") {
            var ref7;
            handleOpenUrl(appLink, "".concat("https://store.hanssem.com", "\n          ").concat(appLink === null || appLink === void 0 ? void 0 : (ref7 = appLink.applink) === null || ref7 === void 0 ? void 0 : ref7.linkUrl).concat(appLink.applink.appLinkAddQuery ? "&" + appLink.applink.appLinkAddQuery : ""));
        }
        if (appLink === null || appLink === void 0 ? void 0 : appLink.goodsInfo) {
            handleOpenUrl(appLink, "".concat("https://store.hanssem.com", "/goods/").concat(appLink.goodsInfo.gdsNo));
        }
    }, [
        handleOpenUrl
    ]);
    var handleLogin = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(_asyncToGenerator(_app_yarn_virtual_next_virtual_769137b2ab_0_cache_next_npm_12_2_3_07d597c2b7_b13b42fbb3_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _app_yarn_virtual_next_virtual_769137b2ab_0_cache_next_npm_12_2_3_07d597c2b7_b13b42fbb3_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_di_container_auth_gateway_client__WEBPACK_IMPORTED_MODULE_7__/* .authGateway */ .h)().loginGateway.exec();
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), []);
    var toast = (0,_design_system_pc__WEBPACK_IMPORTED_MODULE_8__/* .useToast */ .pm)().toast;
    var ref3 = (0,_design_system_pc__WEBPACK_IMPORTED_MODULE_8__/* .useAlert */ .VY)(), handleAlertOpen = ref3.handleOpen;
    var ref4 = (0,_design_system_pc__WEBPACK_IMPORTED_MODULE_8__/* .useConfirm */ .N4)(), handleConfirmOpen = ref4.handleOpen, closeConfirm = ref4.handleClose;
    var handleGoScrap = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        router.push("".concat("https://mall.hanssem.com", "/mypage/wishList.do"));
    }, [
        router
    ]);
    var handleAction = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(param) {
        var message = param.message, action = param.action, type = param.type;
        ;
        if (action === "scrap") {
            toast.success("찜 목록에 추가하였습니다.", {
                placement: "bottom",
                variant: "button",
                actionButton: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_design_system_pc__WEBPACK_IMPORTED_MODULE_8__/* .NewTextButton */ .rT, {
                    size: "lg",
                    isUnderline: true,
                    color: "color_chip.white",
                    onClick: handleGoScrap,
                    width: 74,
                    children: "찜 목록가기"
                }),
                offset: 87,
                zIndex: _styles__WEBPACK_IMPORTED_MODULE_9__/* .TOAST_Z_INDEX */ .kb
            });
        } else {
            switch(type){
                case "toast":
                    toast.success(message, {
                        alignment: "center",
                        placement: "bottom",
                        variant: "basic",
                        offset: 87,
                        zIndex: _styles__WEBPACK_IMPORTED_MODULE_9__/* .TOAST_Z_INDEX */ .kb
                    });
                    break;
                case "alert":
                    handleAlertOpen({
                        content: message,
                        zIndex: _styles__WEBPACK_IMPORTED_MODULE_9__/* .ALERT_Z_INDEX */ .iO
                    });
                    break;
                case "confirm":
                    if (action === "login") {
                        ;
                        handleConfirmOpen({
                            cancelText: "취소",
                            confirmText: "로그인",
                            content: message,
                            width: "370px",
                            isShowCloseButton: true,
                            zIndex: _styles__WEBPACK_IMPORTED_MODULE_9__/* .CONFIRM_Z_INDEX */ .CJ,
                            handleConfirm: function() {
                                handleLogin();
                            },
                            handleCloseButton: function() {
                                closeConfirm();
                            }
                        });
                    } else {
                        handleConfirmOpen({
                            cancelText: "취소",
                            confirmText: "로그인",
                            content: message,
                            width: "370px",
                            zIndex: _styles__WEBPACK_IMPORTED_MODULE_9__/* .CONFIRM_Z_INDEX */ .CJ
                        });
                    }
                    break;
                default:
                    break;
            }
        }
    }, [
        closeConfirm,
        handleAlertOpen,
        handleConfirmOpen,
        handleGoScrap,
        handleLogin,
        toast, 
    ]);
    return {
        handleLink: handleLink,
        handleNewLink: handleNewLink,
        handleAction: handleAction
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useDisplayComponent);


/***/ })

}]);